import React, { useEffect, useRef, useState } from "react";
import "./Suggested.css";
import { db } from "../firebase";
import { ref, onValue } from "firebase/database";

const Suggested = () => {
  const scrollRef = useRef(null);
  const [banners, setBanners] = useState([]);

  // Fetch banners from Firebase
  useEffect(() => {
    const bannerRef = ref(db, "banners");

    const unsub = onValue(bannerRef, (snap) => {
      const data = snap.val() || {};
      const list = Object.values(data);
      setBanners(list);
    });

    return () => unsub();
  }, []);

  // Smooth infinite auto scroll
  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;

    let animationFrame;
    const speed = 0.6; // Adjust speed here

    const scroll = () => {
      container.scrollLeft += speed;

      // When reached half (because we duplicate array)
      if (container.scrollLeft >= container.scrollWidth / 2) {
        container.scrollLeft = 0;
      }

      animationFrame = requestAnimationFrame(scroll);
    };

    animationFrame = requestAnimationFrame(scroll);

    return () => cancelAnimationFrame(animationFrame);
  }, [banners]);

  return (
    <div className="suggested-container">
      <h2>Suggested</h2>

      <div className="suggested-scroll" ref={scrollRef}>
        {[...banners, ...banners].map((item, index) => (
          <a
            key={index}
            href={item.redirectLink}
            target="_blank"
            rel="noopener noreferrer"
            className="suggested-card"
          >
            <img src={item.imageUrl} alt="Banner" />
          </a>
        ))}
      </div>
    </div>
  );
};

export default Suggested;
